import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'

import AlarmModalDays from './AlarmModalDays'

import CloseIcon from '../../assets/icons/close_2.svg'

const AlarmModalAlarmItem = ({
  alarmInfo,
  songId,
  removeAlarmHandler,
  openEditingAlarmHandler,
  allSongsMap,
}) => {
  if (!allSongsMap[songId]) return null

  const { imageUrl, title, artist, genreName } = allSongsMap[songId]
  return (
    <li className="alarm_block_list_item">
      <button className="alarm_block_remove" onClick={removeAlarmHandler}>
        <CloseIcon className="icon close_mod size_mod" />
      </button>
      <div
        role="button"
        className="alarm_block btn_mod"
        onClick={openEditingAlarmHandler}
      >
        <div className="alarm_block_w_img">
          <img
            className="alarm_block_img"
            src={imageUrl}
            alt={`${title} ${t('alarm.BY')} ${artist}`}
          />
        </div>
        <div className="alarm_block_descr">
          <div className="alarm_block_time">{alarmInfo.time}</div>
          <AlarmModalDays activeDays={alarmInfo.days} />
          <div className="alarm_block_category">{genreName}</div>
          <div className="alarm_block_name">{title}</div>
          <div className="alarm_block_artist">{artist}</div>
        </div>
      </div>
    </li>
  )
}

const mapStateToProps = ({ player: { allSongsMap } }) => ({ allSongsMap })

export default connect(mapStateToProps)(AlarmModalAlarmItem)

AlarmModalAlarmItem.propTypes = {
  alarmInfo: PropTypes.object.isRequired,
  allSongsMap: PropTypes.object.isRequired,
  songId: PropTypes.string.isRequired,
  openEditingAlarmHandler: PropTypes.func.isRequired,
  removeAlarmHandler: PropTypes.func.isRequired,
}
